<template>
  <div class="plan-card">

    <h5 style="display: flex;justify-content: space-between;">{{ plan.name }} <Tooltip v-if="isCurrent"
        :tooltipText="`Plan expires in: ${Remainingdays} Days`" position="top"><i
          class="fa-solid fa-circle-info float-end" style="color: gray; opacity: 60%"></i>
      </Tooltip>
    </h5>
    <p>{{ plan.description }}</p>

    <!-- Price section -->
    <div v-if="plan.price !== 'Custom'" class="price">
      <span class="currency">{{ currency }} {{ plan.price }}</span>
      <span class="frequency">/monthly</span>
    </div>
    <div v-else class="custom-price">Custom</div>

    <!-- Buttons section -->
    <div class="buttons-container">
      <div v-for="(button, index) in displayButtons" :key="index">
        <button :class="button.class" style="font-size: medium;" @click="handleButtonClick(button.action)">{{
          button.text }}</button>
      </div>
    </div>
  </div>

  <div class="modal fade" id="ValidationModal" tabindex="-1" aria-labelledby="DeactivatePartnerModalLabel"
    aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
    <div class="modal-dialog  modal-dialog-centered modal-dialog-scrollable border-radius-kj-20">
      <div class="modal-content border-radius-kj-20">
        <div class="modal-header">
          <h4 v-if="this.billing" style="font-weight: 600;">Deactivating your {{ this.billing.object.data.plan.planName
          }} Plan
          </h4>
          <h4 v-else style="font-weight: 600;">Deactivating your Enterprise Plan</h4>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="btn-close"></button>
        </div>
        <div class="modal-body">
          Do you really want to cancel your existing subscription?
          <span class="float-end mt-5">
            <button type="button" class="btn btn-primary secondary " data-bs-dismiss="modal">Cancel</button>
            <button type="button" class=" mx-2 btn btn-primary float-end" @click="CancelSubscription()">Continue to
              Cancel Plan</button>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { calculateRemainingDays } from '../../../platformFeatures/dateUtils';
import Tooltip from "../../modules/tooltip.vue";

export default {
  name: 'PlanCard',
  components: {
    Tooltip,
  },
  props: {
    plan: Object,
    isCurrent: Boolean
  },
  data() {
    return {
      billing: JSON.parse(localStorage.getItem('billingData')),
      PlanStatus: false,
      Remainingdays: "Infinity",
      planDetails: null,
      apiCall: false,
      currency: ''
    }
  },
  methods: {
    ...mapActions([
      'putSubscriptionCancel', 'RefreshBillingDetails', 'postReactivateSubscription', 'getPaymentPage', 'GetPlanCardDetails'
    ]),
    async planContent() {
      var planData = await this.GetPlanCardDetails({
        currency: ""
      });
      // this.PlanFeatures = planData.object.data.features;
      this.planDetails = planData.object.data.allPlans;
      console.log("plan details",this.planDetails)
    },
    async paymentPage(code) {
      const data = {
        subscription_id: this.billing.object.data.subscription.subScriptionId,
        plan: {
          plan_code: code,
        },
        subscriptionId: this.billing.object.data.subscription.subScriptionId
      };
      const response = await this.getPaymentPage(data);
      var url = await response.object.data.hostedpage.url;
      window.open(url, '_self');
    },
    async CancelSubscription() {
      await this.putSubscriptionCancel({
        subscriptionId: this.billing.object.data.subscription.subScriptionId
      });
      await this.RefreshBillingDetails();
      location.reload();
    },
    async reactiveSubscription() {
      await this.postReactivateSubscription({
        subscriptionId: this.billing.object.data.subscription.subScriptionId
      });
      await this.RefreshBillingDetails();
      location.reload();
    },
    async ValidationModal() {
      window.$('#ValidationModal').modal('show');
    },
    handleButtonClick(action) {
      if (action === 'cancel') {
        this.handleCancelOrReactivatePlan();
      } else if (action === 'upgrade') {
        this.openPlans();
      } else if (action === 'enterprise') {
        this.openCalendly();
      } else {
        console.log('Other action:', action);
      }
    },
    handleCancelOrReactivatePlan() {
      if (this.PlanStatus) {
        this.reactiveSubscription()
      } else {
        this.ValidationModal()
      }
      console.log('Cancel Plan clicked');
      // Add your cancellation logic here, e.g., API call or event emission
    },
    openCalendly() {
      window.open("https://calendly.com/nkamble/pmaps-quick-support-new-requirements", '_blank');
    },
    openPlans() {
      this.$emit('change-tab', 'plans');
    },
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),
    displayButtons() {
      if (this.isCurrent) {
        if (this.plan.name === 'Free Trial') {
          return [
            { text: 'Current Plan', class: 'free-current-plan-btn', action: 'current' },
          ];
        } else {
          if (this.plan.name !== 'Enterprise Plan') {
            return [
              { text: 'Current Plan', class: 'current-plan-btn', action: 'current' },
              { text: this.PlanStatus ? 'Reactivate' : 'Cancel Plan', class: 'cancel-btn', action: 'cancel' }
            ];
          } else {
            return [
              { text: 'Current Plan', class: 'current-plan-btn', action: 'current' },
            ];
          }
        }
      } else if (this.plan.name === 'Enterprise Plan') {
        return [{ text: 'Talk to an Expert', class: 'upgrade-btn', action: 'enterprise' }]
      } else {
        return this.plan.buttons.map(button => ({ ...button, action: 'upgrade' }));
      }
    }
  },
  created() {
    if (this.user.isEnterprise == false) {
     this.Remainingdays = calculateRemainingDays(this.billing.object.data.subscription.expiryDate)
     this.PlanStatus = this.billing.object.data.subscription.isCancelled;
    }
    this.currency = this.user.countryCode === 'IN' ? '₹' : '$';
  },
};
</script>

<style scoped>
.plan-card {
  border: none;
  padding: 20px 16px;
  margin: 8px;
  border-radius: 8px;
  background: white;
  width: 340px;
  height: 200px;
  box-shadow: 0 1px 3px rgba(101, 101, 101, 0.3);
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.plan-card h3 {
  font-size: 18px;
  font-weight: 600;
  color: #111827;
  margin: 0 0 4px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.plan-card h5::after {
  font-size: 14px;
  color: #9CA3AF;
  cursor: pointer;
}

.plan-card p:first-of-type {
  font-size: 13px;
  color: #6B7280;
  margin: 0 0 16px 0;
  font-weight: 400;
}

.plan-card .price {
  font-size: 28px;
  font-weight: 700;
  color: #111827;
  margin: 0 0 16px 0;
  display: flex;
  align-items: baseline;
}

.plan-card .price .currency {
  font-size: 28px;
}

.plan-card .price .frequency {
  font-size: 14px;
  font-weight: 400;
  color: #6B7280;
  margin-left: 4px;
}

.plan-card .buttons-container {
  display: flex;
  gap: 12px;
}

.plan-card button {
  padding: 10px 16px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  flex: 1;
  transition: all 0.2s ease;
  margin: 0 4px;
}

.plan-card button:first-child {
  margin-left: 0;
}

.plan-card button:last-child {
  margin-right: 0;
}

.plan-card .current-plan-btn {
  background: #a088ff;
  color: #ffffff;
  border: 1px solid #C4B5FD;
  width: 10rem;
}

.plan-card .free-current-plan-btn {
  background: #a088ff;
  color: #ffffff;
  border: 1px solid #C4B5FD;
  width: 19rem;
}

.plan-card .cancel-btn {
  background: transparent;
  color: #6B7280;
  border: 1px solid #E5E7EB;
  width: 8rem;
}

.plan-card .cancel-btn:hover {
  background: #F9FAFB;
  color: #374151;
}

.plan-card .upgrade-btn {
  background: #4F46E5;
  color: white;
  width: 19rem;
}

.plan-card .upgrade-btn:hover {
  background: #4338CA;
}

.plan-card .talk-expert-btn {
  background: #4F46E5;
  color: white;
}

.plan-card .talk-expert-btn:hover {
  background: #4338CA;
}

.plan-card .custom-price {
  font-size: 28px;
  font-weight: 700;
  color: #111827;
  margin: 0 0 16px 0;
}
</style>